import React from 'react'
import cn from 'classnames'
import { WbIcon } from '@workbench/react/dist'
import { ExternalLink, InfoModal, Link } from 'components'
import { useModal } from 'hooks/useModal'
import classes from './Footer.module.scss'
import appClasses from 'App.module.scss'
import { ImpressumModal } from './ImpressumModal'
import { PrivacyStatementModal } from './PrivacyStatementModal'
import { useTranslation } from 'react-i18next'

const CustomerSupportModal = () => {
  const [showModal, openModal, closeModal] = useModal()
  const { t } = useTranslation()

  return (
    <>
      <button
        className={cn(
          'wb-link',
          'wb-link--small',
          'wb-link--theme-dark',
          classes.button
        )}
        onClick={openModal}
      >
        {t('components.footer.footer.customerSupportModal.buttonText')}
      </button>

      {showModal && (
        <InfoModal
          onClose={closeModal}
          headline={t('components.footer.footer.customerSupportModal.heading')}
        >
          {t('components.footer.footer.customerSupportModal.contactUs')}{' '}
          <Link to="/inquiries/new" variant="inline">
            {t('components.footer.footer.customerSupportModal.contactForm')}
          </Link>{' '}
          {t('components.footer.footer.customerSupportModal.phoneService')}
          <div className={classes.phoneNumber}>
            <WbIcon name="call" />
            {t('global.mbvm.phoneNumber')}
          </div>
          <small className={classes.phoneDetails}>
            {t('components.footer.footer.customerSupportModal.availability')}
          </small>
        </InfoModal>
      )}
    </>
  )
}

export const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className={cn(appClasses.footer, classes.footer)}>
      <div className={classes.content}>
        <ImpressumModal />
        <CustomerSupportModal />

        <Link
          variant="small"
          theme="dark"
          to={
            process.env.PUBLIC_URL +
            '/250918_AMB_2025_final.pdf'
          }
          className={classes.link}
          target="_blank"
        >
          {t('components.footer.footer.rentCondition')}
        </Link>

        <PrivacyStatementModal />

        <ExternalLink
          href={t('components.footer.bpo.url')}
          variant="small"
          theme="dark"
          className={classes.link}
          target="_blank"
        >
          {t('components.footer.bpo.heading')}
        </ExternalLink>
      </div>
    </footer>
  )
}
